import { render, staticRenderFns } from "./newspaper-form.vue?vue&type=template&id=3a8fd956"
import script from "./newspaper-form.vue?vue&type=script&lang=js"
export * from "./newspaper-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports